import { render, staticRenderFns } from "./NewBranchesSearch.vue?vue&type=template&id=4a900724&"
import script from "./NewBranchesSearch.vue?vue&type=script&lang=js&"
export * from "./NewBranchesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports